import { HeartIcon } from '@radix-ui/react-icons'
import { StatusBadge } from '../../v3/components/StatusBadge'
import { GlassBox } from './_shared/GlassBox'
import { Invoice, Pencil, Person, RollbackClock } from './icons'
import { filterAdditionalProducts } from '../../v3/helpers/additionalProducts'
import { PrimaryButton } from './_shared/Buttons/PrimaryButton'
import { SecondaryButton } from './_shared/Buttons/SecondaryButton'
import { fuelList } from './helpers/productKeys'
import { getReturnDateTitleAndText } from '../../../../utils/helpers/helpers.cars'

export function AgreementDetails({ car, setShowEditDriver, setShowSendMessage, setShowLostFuelCard }) {
  const hasFuelCardOrCharingChip = car.additionalProducts?.some((product: any) =>
    fuelList.includes(product?.AgreementCode),
  )

  const { title: returnDateTitle, text: returnDateText } = getReturnDateTitleAndText(car)

  return (
    <GlassBox>
      <div className="flex gap-4 items-center">
        <span className="text-2xl">Avtaledetaljer</span>
        <StatusBadge status={car.status.toLowerCase()} />
      </div>
      <div className="flex flex-row gap-2">
        <PrimaryButton onClick={() => setShowSendMessage(true)}>Send melding</PrimaryButton>
        <SecondaryButton disabled={!hasFuelCardOrCharingChip} onClick={() => setShowLostFuelCard(true)}>
          Mistet drivstoffkort / ladebrikke
        </SecondaryButton>
      </div>
      <div className="flex flex-col gap-4">
        <AgreementDetailsItem
          title="Registert fører"
          icon={<Person />}
          details={car?.driverName}
          action={() => setShowEditDriver(true)}
          actionIcon={<Pencil />}
        />
        <AgreementDetailsItem
          title="Samlefakturakode"
          icon={<Invoice />}
          details={`${car?.consolidatedInvoiceCode || '-- --'}`}
        />
        <AgreementDetailsItem title={returnDateTitle} icon={<RollbackClock />} details={returnDateText} />
        <AgreementDetailsItem
          title="Tilleggstjenester"
          icon={<HeartIcon />}
          details={`${filterAdditionalProducts(car?.additionalProducts || []).length} aktive`}
        />
      </div>
    </GlassBox>
  )
}

export function AgreementDetailsItem({
  title,
  icon,
  action,
  actionIcon,
  details,
}: {
  title: string
  icon: React.ReactNode
  action?: () => void
  actionIcon?: React.ReactNode
  details: string
}) {
  return (
    <div className="flex relative gap-4 bg-white p-4 rounded-lg">
      <p className="text-old-primary">{icon}</p>
      <div className="flex flex-col gap-1">
        <p className="font-bold text-black">{title}</p>
        <p className="capitalize text-old-offGrey">{details}</p>
      </div>
      {action && (
        <button className="absolute top-3 right-3 text-old-primary" onClick={() => action()}>
          {actionIcon}
        </button>
      )}
    </div>
  )
}
